<template>
  <div>
    <v-expansion-panels v-model="meetingCardPanel">
      <a-expansion-panel>
        <v-expansion-panel-header>
          Items For Approval
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row no-gutters>
            <v-col md="11">
              <v-row no-gutters>
                <v-col cols="12" sm="4">
                  <h2>アジェンダが入ります</h2>
                  <h4>
                    <li class="topic-list-style">アジェンダが入ります</li>
                  </h4>
                </v-col>
                <v-col cols="12" sm="2">
                  <div class="text-left">
                    <a-chip small outlined class="high">High</a-chip>
                    <a-chip small outlined class="low mr-2 ml-2"
                      >999 min</a-chip
                    >
                    <a-btn x-small color="secondary" width="24" min-width="24">
                      <v-icon size="16" color="neutralGray1"> mdi-pencil</v-icon>
                    </a-btn>
                  </div>
                </v-col>
                <v-col cols="12" sm="3">
                  <v-row no-gutters>
                    <v-col cols="12" sm="12">
                      <v-list
                        dense
                        class="mb-0"
                        style="margin-top: -15px !important"
                      >
                        <v-list-item
                          v-for="data in users"
                          :key="data.title"
                          color="primary"
                        >
                          <v-list-item-avatar size="32">
                            <v-img
                              contain
                              src="@/assets/images/NoPhotoIcon.png"
                            ></v-img>
                          </v-list-item-avatar>
                          <v-list-item-content>
                            <v-list-item-title
                              class="label-m"
                              v-text="data.title"
                            ></v-list-item-title>
                            <v-list-item-subtitle
                              class="label-s"
                              v-text="data.email"
                            ></v-list-item-subtitle>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                    </v-col>
                    <v-col cols="12" sm="12" class="ml-4">
                      <v-btn small icon>
                        <v-icon size="20" color="neutralGray"
                          >mdi-account-edit</v-icon
                        >
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" sm="3">
                  <div class="parentInput" v-cloak>
                    <input
                      id="inputID"
                      v-show="false"
                      type="file"
                      class="input inputfile"
                    />
                    <label
                      for="inputID"
                      class="pa-1 label-s"
                      style="
                        border: dashed 1px lightgray;
                        border-radius: 3px;
                        color: #999999;
                      "
                    >
                      <v-icon size="20" class="mr-1" color="neutralGray1"
                        >mdi-attachment</v-icon
                      >
                      click or drag and drop files here
                    </label>
                  </div>

                  <v-list dense class="pt-0 pb-0">
                    <v-list-item class="pl-0">
                      <v-icon class="mr-1" icon="mdi-file-document" size="14"
                        >mdi-file-document</v-icon
                      >
                      <v-list-item-content>
                        <span class="body-m primary--text">
                          ドキュメントファイル名
                          <v-btn small icon>
                            <v-icon size="11" color="neutralGray1"
                              >mdi-delete</v-icon
                            >
                          </v-btn>
                        </span>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="3">
                  <a-chip outlined color="primary" class="opened"
                    >OPENED</a-chip
                  >
                  <v-btn-toggle
                    active-class="toggle-active-class"
                    class="a-toggle-button ml-4"
                    v-model="toggle_status"
                  >
                    <a-btn value="open">
                      <span class="hidden-sm-and-down">Open</span>
                    </a-btn>

                    <a-btn value="close">
                      <span class="hidden-sm-and-down">Close</span>
                    </a-btn>
                  </v-btn-toggle>
                </v-col>
                <v-col cols="12" sm="3" class="text-left">
                  <v-row no-gutters class="mb-5">
                    <v-btn-toggle
                      active-class="toggle-active-class"
                      class="a-toggle-button"
                    >
                      <a-btn value="left">
                        <span class="hidden-sm-and-down">Approval</span>
                      </a-btn>

                      <a-btn value="center">
                        <span class="hidden-sm-and-down">Reject</span>
                      </a-btn>

                      <a-btn value="right">
                        <span class="hidden-sm-and-down">Abstain</span>
                      </a-btn>
                    </v-btn-toggle>
                  </v-row>
                </v-col>
                <v-col cols="12" sm="3" class="text-left">
                  <a-btn color="primaryDark" class="ml-4"> Result</a-btn>
                </v-col>
              </v-row>
            </v-col>
            <v-col md="1">
              <div class="text-center">
                <div>
                  <a-btn
                    disabled
                    class="arrow-up-thick"
                    x-small
                    color="primaryDark"
                    width="24"
                    min-width="24"
                  >
                    <v-icon size="16" color="#fff"> mdi-arrow-up-thick</v-icon>
                  </a-btn>
                </div>
                <a-btn
                  class="arrow-down-thick"
                  x-small
                  color="primaryDark"
                  width="24"
                  min-width="24"
                >
                  <v-icon size="16" color="#fff"> mdi-arrow-down-thick</v-icon>
                </a-btn>
                <div class="mt-2">
                  <a-btn x-small color="primaryDark" width="24" min-width="24">
                    <v-icon size="16" color="#fff"> mdi-delete</v-icon>
                  </a-btn>
                </div>
              </div>
            </v-col>
          </v-row>
          <v-divider class="mt-2 mb-5"></v-divider>
          <v-row no-gutters>
            <v-col md="11">
              <v-row no-gutters>
                <v-col cols="12" sm="4">
                  <h2>アジェンダが入ります</h2>
                  <h4>
                    <li class="topic-list-style">アジェンダが入ります</li>
                  </h4>
                </v-col>
                <v-col cols="12" sm="2">
                  <div class="text-left">
                    <a-chip small outlined class="high">High</a-chip>
                    <a-chip small outlined class="low mr-2 ml-2"
                      >999 min</a-chip
                    >
                    <a-btn x-small color="secondary" width="24" min-width="24">
                      <v-icon size="16" color="neutralGray1"> mdi-pencil</v-icon>
                    </a-btn>
                  </div>
                </v-col>
                <v-col cols="12" sm="3">
                  <v-row no-gutters>
                    <v-col cols="12" sm="12">
                      <v-list
                        dense
                        class="mb-0"
                        style="margin-top: -15px !important"
                      >
                        <v-list-item
                          v-for="data in users"
                          :key="data.title"
                          color="primary"
                        >
                          <v-list-item-avatar size="32">
                            <v-img
                              contain
                              src="@/assets/images/NoPhotoIcon.png"
                            ></v-img>
                          </v-list-item-avatar>
                          <v-list-item-content>
                            <v-list-item-title
                              class="label-m"
                              v-html="data.title"
                            ></v-list-item-title>
                            <v-list-item-subtitle
                              class="label-s"
                              v-html="data.email"
                            ></v-list-item-subtitle>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                    </v-col>
                    <v-col cols="12" sm="12" class="ml-4">
                      <v-btn small icon>
                        <v-icon size="16" color="neutralGray"
                          >mdi-account-edit</v-icon
                        >
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" sm="3">
                  <div class="parentInput" v-cloak>
                    <input
                      id="inputID"
                      v-show="false"
                      type="file"
                      class="input inputfile"
                    />
                    <label
                      for="inputID"
                      class="pa-1 label-s"
                      style="
                        border: dashed 1px lightgray;
                        border-radius: 3px;
                        color: #999999;
                      "
                    >
                      <v-icon size="20" class="mr-1" color="neutralGray1"
                        >mdi-attachment</v-icon
                      >
                      click or drag and drop files here
                    </label>
                  </div>

                  <v-list dense class="pt-0 pb-0">
                    <v-list-item class="pl-0">
                      <v-icon class="mr-1" icon="mdi-file-document" size="14"
                        >mdi-file-document</v-icon
                      >
                      <v-list-item-content>
                        <span class="body-m primary--text">
                          ドキュメントファイル名
                          <v-btn small icon>
                            <v-icon size="11" color="neutralGray1"
                              >mdi-delete</v-icon
                            >
                          </v-btn>
                        </span>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="3">
                  <a-chip outlined color="primary" class="opened"
                    >OPENED</a-chip
                  >
                  <v-btn-toggle
                    active-class="toggle-active-class"
                    class="a-toggle-button ml-4"
                    v-model="toggle_status"
                  >
                    <a-btn value="open">
                      <span class="hidden-sm-and-down">Open</span>
                    </a-btn>

                    <a-btn value="close">
                      <span class="hidden-sm-and-down">Close</span>
                    </a-btn>
                  </v-btn-toggle>
                </v-col>
                <v-col cols="12" sm="3" class="text-left">
                  <v-row no-gutters class="mb-5">
                    <v-btn-toggle
                      active-class="toggle-active-class"
                      class="a-toggle-button"
                    >
                      <a-btn value="left">
                        <span class="hidden-sm-and-down">In person</span>
                      </a-btn>

                      <a-btn value="center">
                        <span class="hidden-sm-and-down">Remotely</span>
                      </a-btn>

                      <a-btn value="right">
                        <span class="hidden-sm-and-down">Absent</span>
                      </a-btn>
                    </v-btn-toggle>
                  </v-row>
                </v-col>
                <v-col cols="12" sm="3" class="text-left">
                  <a-btn color="primaryDark" class="ml-4"> Result</a-btn>
                </v-col>
              </v-row>
            </v-col>
            <v-col md="1">
              <div class="text-center">
                <div>
                  <a-btn
                    disabled
                    class="arrow-up-thick"
                    x-small
                    color="primaryDark"
                    width="24"
                    min-width="24"
                  >
                    <v-icon size="16" color="#fff"> mdi-arrow-up-thick</v-icon>
                  </a-btn>
                </div>
                <a-btn
                  class="arrow-down-thick"
                  x-small
                  color="primaryDark"
                  width="24"
                  min-width="24"
                >
                  <v-icon size="16" color="#fff"> mdi-arrow-down-thick</v-icon>
                </a-btn>
                <div class="mt-2">
                  <a-btn x-small color="primaryDark" width="24" min-width="24">
                    <v-icon size="16" color="#fff"> mdi-delete</v-icon>
                  </a-btn>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </a-expansion-panel>
    </v-expansion-panels>
  </div>
</template>
<style scoped>
.arrow-up-thick {
  border-radius: 4px 4px 0px 0px !important;
}
.arrow-down-thick {
  border-radius: 0px 0px 4px 4px !important;
}
.topic-list-style {
  list-style-type: disc;
  margin-left: 10px;
}
.a-toggle-button.v-btn-toggle:not(.v-btn-toggle--group) .v-btn.v-btn {
  border-color: var(--v-primaryDark-base) !important;
}
</style>
<script>
import ABtn from "./ABtn.vue";
import AChip from "./AChip.vue";
import AList from "./AList.vue";
import AExpansionPanel from "./AExpansionPanel.vue";
export default {
  name: "MeetingCard",
  components: { ABtn, AChip, AList, AExpansionPanel },
  data() {
    return {
      meetingCardPanel: 0,
      toggle_status: "open",
      toggle_response: "Approval",
      users: [
        {
          title: "Jason Oner",
          email: "jsonOnwer@1234gmil.com",
        },
        {
          title: "Max Oner",
          email: "maxOnwer@0987gmil.com",
        },
        // {
        //   title: "Zhao Oner",
        //   email: "zhaoOnwer@134gmil.com",
        // },
        // {
        //   title: "Alex Oner",
        //   email: "alexOnwer@097gmil.com",
        // },
      ],
    };
  },
};
</script>

